import { createVNode as o, mergeProps as l } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/EditFilled.js";
import m from "../components/PfIcon.js";
const t = (r, e) => {
  const i = {
    ...r,
    ...e.attrs
  };
  return o(m, l(i, {
    icon: d
  }), null);
};
t.displayName = "EditFilled";
t.inheritAttrs = !1;
export {
  t as default
};
